module.exports = __webpack_public_path__ + "static/1497d52c96a0e18a6bf25961a79e3c74.svg";